export default __webpack_public_path__ + "static/media/no-results.a42642ab.png";